module.exports = __webpack_public_path__ + "static/media/TermsAndConditions.79b301f4.md";